import { gtag_event as gtag_event_lgp } from '../page-template/lgp/gtag-init';
import { gtag_event as gtag_event_two } from '../routes/gtag-init';
import { gtag_event as gtag_event_page_builder } from '../page-template/page-builder/gtag-init';
import { gtag_event as gtag_event_elementor } from '../custom-elementor-widget/gtag-init';
import { getCookie } from './cookie';

var is_tracker = false;
var validated = false;
var otp_input_value = [];
var resendTimer = null;
var passed_cancel_wait = false;
var cancelTimer = null;
var cancel_wait_second  = 30;


['template-microsite-lgp', 'template-microsite-two', 'template-microsite-page-builder', 'template-microsite-elementor'].forEach(function(template) {
  if(document.body.classList.contains(template)) {
    is_tracker = true;
  }
});

// eslint-disable-next-line no-undef
var gl_params = global_params;

export function is_completed_otp(phone_number) {
    validated = get_cookie('otp_validated');
    return validated == phone_number ? true : false;
}


export function check_otp_session(type) {
  if(type == 'init') {
    if(sessionStorage.getItem('otp_last_timer') == -1){
      $('.btn-whatsapp-general').attr('data-target', '#whatsapp-form-modal');
      $('.btn-virtual-tour-lead, .btn-faq-lead').removeAttr('data-toggle data-target');
    }else{
      const today = new Date().toLocaleDateString('id-ID');
      if(sessionStorage.getItem('otp_last_request') == today){
        $('.btn-whatsapp-general, .btn-virtual-tour-lead, .btn-faq-lead').attr({ 'data-toggle':'modal', 'data-target':'#otp-modal' })
        $('#otp_phone_number').text(sessionStorage.getItem('otp_phone_number'));
        otp_input(sessionStorage.getItem('otp_phone_number'), sessionStorage.getItem('otp_next_action'));
        otp_start_timer(sessionStorage.getItem('otp_last_timer'));
      }else{
        otp_reset_timer()
      }
    }
  }

  if(type == 'on_timer') {
    if(sessionStorage.getItem('otp_last_timer') == -1){
      return false;
    }
    return true;
  }
}


if(is_otp_enable() == true){
  check_otp_session('init');
  otp_input();
}else{
  otp_reset_timer()
  sessionStorage.setItem('otp_phone_number', null)
  sessionStorage.setItem('otp_next_action', null)
  sessionStorage.setItem('otp_requestId', null)
  sessionStorage.setItem('otp_source_modal', null)
  sessionStorage.setItem('otp_nextEventWait', null)
}

function send_otp(phone_number) {

  return fetch(gl_params.otp.ajax_url,{
    method: 'POST',
    credentials: 'same-origin',
    headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded'}),
    body: new URLSearchParams({
      action: gl_params.otp.send_otp.action,
      phone_number: phone_number,
    }),
  })
  .then(function(response) {
    return response.json().then(function(json) {
      if (!response.ok || json.success === false) {
        return {
          success: false,
          data: json.data || { errors: [{ message: 'Gagal mengirim OTP. Silakan coba lagi.' }] },
        };
      }
      return json;
    });
  })
  .catch(function() {
    return {
      success: false,
      data: { errors: [{ message: 'Gagal mengirim OTP. Silakan coba lagi.' }] },
    };
  });
}


function verify_otp(code){

  return fetch(gl_params.otp.ajax_url,{
    method: 'POST',
    credentials: 'same-origin',
    headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded'}),
    body: new URLSearchParams({
      action: gl_params.otp.verify_otp.action,
      code: code,
      requestId: sessionStorage.getItem('otp_requestId'),
    }),
  })
  .then(function(response) {
    if (!response.ok) {
        throw new Error('HTTP status '+ response.status);
    }
    return response.json();
  })
}

function cancel_otp(requestId){

  return fetch(gl_params.otp.ajax_url,{
    method: 'POST',
    credentials: 'same-origin',
    headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded'}),
    body: new URLSearchParams({
      action: gl_params.otp.cancel_otp.action,
      requestId: requestId,
    }),
  })
  .then(function(response) {
    if (!response.ok) {
        throw new Error('HTTP status '+ response.status);
    }
    return response.json();
  })
}

function show_otp_form(show, phone_number, next_action, source_modal) {
  if(true === show){
    return send_otp(phone_number).then(data => {

      if (!data || data.success === false || !data.data || !data.data.data || !data.data.data.requestOtp) {
        const errors = (data && data.data && data.data.errors) ? data.data.errors : [{ message: 'Gagal mengirim OTP. Silakan coba lagi.' }];
        return { errors: errors };
      }

      let response = data.data.data.requestOtp;
      let is_error = data.data.hasOwnProperty('errors');

      //if error exist then we bypass the otp
      if(is_error) return data.data;
        
      let next_event_wait = (response.nextEventWait == 0 ? 60 : response.nextEventWait);
      sessionStorage.setItem('otp_requestId', response.requestId)
      sessionStorage.setItem('otp_next_action', next_action)
      sessionStorage.setItem('otp_phone_number', phone_number)
      sessionStorage.setItem('otp_source_modal', source_modal)
      sessionStorage.setItem('otp_last_request', new Date().toLocaleDateString('id-ID'))
      sessionStorage.setItem('otp_nextEventWait', next_event_wait)
      $(source_modal).modal('hide');
      otp_start_timer(next_event_wait);
      $('#otp_phone_number').text(phone_number);
      $('#otp-modal').modal('show');
      $('#otp_countdown_notice').show();
      $('#otp_timer').show();
      $('#otp_resend_notice').addClass('d-none');
      $('#otp_resend').addClass('d-none');
      $('#otp_field_container :input').removeClass('success failed');
      $('#otp_field_container :input').removeAttr('disabled');
      $('#otp_status').text('').removeClass('success failed');
      $('.btn-whatsapp-general, .btn-virtual-tour-lead, .btn-faq-lead').attr({ 'data-toggle':'modal', 'data-target':'#otp-modal' })

      if(source_modal == ''){
        $(next_action).attr( { 'data-toggle':'modal', 'data-target':'#otp-modal' } );
      }
      return false
      
    })
  }else{
    let source_modal = sessionStorage.getItem('otp_source_modal');
    $('#otp-modal').modal('hide');
    if(source_modal != ''){
      $(source_modal).modal('show');
    }
  }
}


function otp_input() {
  const inputs = document.querySelectorAll('#otp_field_container > *[id]');
  for (let i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('keydown', function(event) {
          if (event.key === 'Backspace') {
              delete otp_input_value[i];
              inputs[i].value = '';
          } else {
              if (i === inputs.length - 1 && inputs[i].value !== '') {
                  return true;
              } else if ((event.keyCode > 47 && event.keyCode < 58) || (event.keyCode >= 96 && event.keyCode <= 105)) {
                  inputs[i].value = event.key;
                  otp_input_value[i] = event.key;
                  if (i !== inputs.length - 1) inputs[i + 1].focus();
                  event.preventDefault();
              } else if (event.keyCode > 64 && event.keyCode < 91) {
                  inputs[i].value = String.fromCharCode(event.keyCode);
                  otp_input_value[i] = String.fromCharCode(event.keyCode);
                  if (i !== inputs.length - 1) inputs[i + 1].focus();
                  event.preventDefault();
              }
          }

          if(otp_input_value.length == 1) {
            $('#otp_field_container :input').removeClass('failed');
            $('#otp_status').text('');
          }

          if (otp_input_value.length == 6) {

              verify_otp(otp_input_value.join('')).then(data => {
                let response = data.data.data.verifyOtp;
                let is_error = data.data.hasOwnProperty('errors');
                let source_modal = sessionStorage.getItem('otp_source_modal');
                let otp_phone_number = sessionStorage.getItem('otp_phone_number');
                let next_action = sessionStorage.getItem('otp_next_action');
                if(is_error) {
                  is_tracker && trackerController('OTP failed', 'wrong otp')
                  otp_input_value = [];
                  $('#otp_field_container :input').val('');
                  $('#otp_field_container :input').addClass('failed');
                  $('#otp_status').text('Kode yg Anda masukan salah, pastikan kode OTP yg Anda masukan benar').addClass('failed');
                }else{
                  if(true === response.isSuccess) {
                    set_secure_cookie('otp_validated', otp_phone_number, 1);
                    sessionStorage.setItem('otp_phone_number', null)
                    sessionStorage.setItem('otp_next_action', null)
                    sessionStorage.setItem('otp_requestId', null)
                    sessionStorage.setItem('otp_nextEventWait', null)
                    $('#otp_field_container :input').addClass('success');
                    $('#otp_field_container :input').attr('disabled');
                    $('#otp_status').text('Input OTP berhasil').addClass('success');
                    $('#otp-modal').modal('hide');
                    $('.btn-whatsapp-general').attr('data-target', '#whatsapp-form-modal');
                    $('.btn-virtual-tour-lead, .btn-faq-lead').removeAttr('data-toggle data-target');
                    if(source_modal == ''){
                      $(next_action).removeAttr('data-toggle data-target');
                    }else{
                      $(source_modal).modal('show');
                    }
                    document.querySelector(next_action).click();
                    is_tracker && trackerController('OTP success', otp_phone_number)
                    pushMarketingGtmConversion(otp_phone_number, next_action);
                    otp_reset_form()
                    $('#otp_countdown_notice').hide();
                    otp_reset_timer();
                  }else{
                    $('#otp_field_container :input').addClass('failed');
                    $('#otp_status').text('Kode yg Anda masukan salah, pastikan kode OTP yg Anda masukan benar').addClass('failed');
                  }
                }
                
              })
          }
      });
  }

}

function otp_start_timer(second) {
  let passed_cancel_second = sessionStorage.getItem('otp_nextEventWait') - cancel_wait_second;
  let cancel_wait_second_timer = cancel_wait_second;
  resendTimer = setInterval(function(){
    if(second < 0){
      clearInterval(resendTimer);
      $('#otp_countdown_notice').hide();
      $('#otp_timer').hide();
      $('#otp_resend_notice').removeClass('d-none');
      $('#otp_resend').removeClass('d-none');
      $('.btn-whatsapp-general').attr('data-target', '#whatsapp-form-modal');
      is_tracker && trackerController('OTP failed', 'time out')
    } else {
      document.getElementById('otp_timer').innerHTML = secondsToTime(second);
    }
    

    if(second <= passed_cancel_second) {
      passed_cancel_wait = true
    }

    sessionStorage.setItem('otp_last_timer', second)
    second -= 1;
    cancelTimer = cancel_wait_second_timer -= 1;
  }, 1000);
}

function otp_reset_timer() {
    clearInterval(resendTimer);
    resendTimer = null;
    sessionStorage.setItem('otp_last_timer', -1);
    passed_cancel_wait = false;
    cancelTimer = null;
}

function otp_reset_form() {
  $('#otp_field_container :input').val('');
  $('#otp_resend_notice, #otp_resend').hide();
  $('#otp_countdown_notice').text('Kirim Ulang OTP ');
  $('#otp_countdown_notice').show();
}


export function otp_init(current_form_class, e, number, btn_submit) {
  
  if(is_otp_enable() == false){
    return true; //stop from displaying otp
  }

  console.info(is_otp_enable());

  let whatsapp_clean_number = set_whatsapp_clean_number(number);

  if(false === is_completed_otp(whatsapp_clean_number)){

    console.info('not complete otp');
    $(current_form_class + ' .loader').show();
    let otp = false
    let source_modal = e.target.closest('.modal') != null ? '#'+e.target.closest('.modal').id+'' : '';
    show_otp_form(true, whatsapp_clean_number, btn_submit, source_modal).then(data => {

      console.info('show otp form');
      $(current_form_class + ' .loader').hide();
      otp = data

      console.info(data);

      if (!data || data.hasOwnProperty('errors')) {
        const errors = (data && data.errors) ? data.errors : [{ message: 'Gagal mengirim OTP. Silakan coba lagi.' }];
        // Handle rate limiting error (too many OTP requests)
        if(errors[0].message && errors[0].message.toLowerCase().includes('too many otp requests')){
          $(current_form_class + ' .message-failed').show();
          $(current_form_class + ' .message-failed ').text('Terlalu banyak permintaan OTP. Silakan coba lagi beberapa menit lagi.');
          return;
        }
        
        // Handle errors with extension codes
        if(errors[0].extensions && errors[0].extensions.code){
          if(errors[0].extensions.code == 10){
            $(current_form_class + ' .message-failed').show();
            $(current_form_class + ' .message-failed ').text(errors[0].message + ' please use different number or wait for a few minutes ');
          }
    
          if(errors[0].extensions.code == 3){
            $(current_form_class + ' .message-failed').show();
            $(current_form_class + ' .message-failed ').text(errors[0].message);
          }
        } else {
          // Fallback for other errors without code
          $(current_form_class + ' .message-failed').show();
          $(current_form_class + ' .message-failed ').text(errors[0].message || 'Terjadi kesalahan. Silakan coba lagi.');
        }
      }  
    }).catch(function() {
      $(current_form_class + ' .loader').hide();
      $(current_form_class + ' .message-failed').show();
      $(current_form_class + ' .message-failed ').text('Gagal mengirim OTP. Silakan coba lagi.');
    })
    return otp;
  }
}

function is_otp_enable(){
  // eslint-disable-next-line no-undef
  let otp_param =  gl_params.otp && gl_params.otp.enable_otp;
  let is_otp_params_enable =  (typeof otp_param != 'undefined' ? otp_param : false);
  if(is_otp_params_enable == true){
    return true;
  }
  return false;
}

$(document).on('click', '#otp_change_number', function(){

  if(passed_cancel_wait == true) {
    cancel_otp(sessionStorage.getItem('otp_requestId')).then(data => {
      let is_error = data.data.hasOwnProperty('errors');
      let is_already_cancelled = is_error && data.data.errors[0].extensions && data.data.errors[0].extensions.code === 6;
  
       // Treat "already cancelled" (code 6) as success
       if(!is_error || is_already_cancelled){
        show_otp_form(false);
        sessionStorage.setItem('otp_phone_number', null)
        sessionStorage.setItem('otp_next_action', null)
        sessionStorage.setItem('otp_requestId', null)
        sessionStorage.setItem('otp_nextEventWait', null)
        $('.btn-whatsapp-general').attr('data-target', '#whatsapp-form-modal');
        $('.btn-virtual-tour-lead, .btn-faq-lead').removeAttr('data-toggle data-target');
        if(sessionStorage.getItem('otp_source_modal') == ''){
          $(sessionStorage.getItem('otp_next_action')).removeAttr('data-toggle data-target');
        }
        otp_reset_timer();
       }else{
         alert('please wait a few minutes later or refresh the page')
       }
    });
  }else{
    alert('To change number please wait for '+cancelTimer+' second')
  }


});

$(document).on('click', '#otp_resend', function(){
  $('#otp_countdown_notice').text('Mengirim ulang OTP...');
  cancel_otp(sessionStorage.getItem('otp_requestId')).then(data => {
    let is_error = data.data.hasOwnProperty('errors');
    let is_already_cancelled = is_error && data.data.errors[0].extensions && data.data.errors[0].extensions.code === 6;

     // Treat "already cancelled" (code 6) as success
     if(!is_error || is_already_cancelled){
      sessionStorage.setItem('otp_nextEventWait', null)
      let otp_phone_number = sessionStorage.getItem('otp_phone_number');
      otp_reset_timer();
      $('#otp_countdown_notice').text('Kirim Ulang OTP ');
      show_otp_form(true, otp_phone_number, sessionStorage.getItem('otp_next_action'), sessionStorage.getItem('otp_source_modal'));

     }else{
       alert('please wait a few minutes later or refresh the page')
     }
  });

});

function set_secure_cookie(name, value, days) {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }
    
    // Set cookie with security flags
    // Note: httpOnly flag can only be set server-side
    const secureFlag = window.location.protocol === 'https:' ? '; Secure' : '';
    const sameSite = '; SameSite=Strict';
    const path = '; path=/';
    
    document.cookie = name + '=' + (value || '') + expires + path + secureFlag + sameSite;
}

function get_cookie(cookiename) {
    let name = cookiename + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
}

function secondsToTime(e){
  var m = Math.floor(e % 3600 / 60).toString().padStart(2,'0'),
      s = Math.floor(e % 60).toString().padStart(2,'0');
  
  return '('+m + ':' + s+')';
  //return `${h}:${m}:${s}`;
}


function trackerController(status, label) {
  if(document.body.classList.contains('template-microsite-lgp')) {
    gtag_event_lgp(status, label);
  }
  
  if(document.body.classList.contains('template-microsite-two')) {
    gtag_event_two(status, label);
  }
  
  if(document.body.classList.contains('template-microsite-page-builder')) {
    gtag_event_page_builder(status, label);
  }

  if(document.body.classList.contains('template-microsite-elementor')) {
    gtag_event_elementor(status, label);
  }
}

const EXCLUDED_LEADS_FORM_FIELDS = ['action', 'submit_status'];

function isExcludedLeadsFormField(fieldName) {
  if (!fieldName || EXCLUDED_LEADS_FORM_FIELDS.indexOf(fieldName) !== -1) {
    return true;
  }

  return fieldName.indexOf('nonce') !== -1;
}

function collectLeadsFormPayload(form) {
  const payload = {};

  if (!form) {
    return payload;
  }

  form.querySelectorAll('input[name], select[name], textarea[name]').forEach(function(field) {
    const fieldName = field.getAttribute('name');

    if (isExcludedLeadsFormField(fieldName)) {
      return;
    }

    payload[fieldName] = field.value != null ? String(field.value).trim() : '';
  });

  return payload;
}

function applyCookieFallbackToFormPayload(form, payload) {
  if (!form) {
    return payload;
  }

  form.querySelectorAll('input[name], select[name], textarea[name]').forEach(function(field) {
    const fieldName = field.getAttribute('name');

    if (isExcludedLeadsFormField(fieldName) || payload[fieldName]) {
      return;
    }

    const cookieValue = getCookie('nndc_' + fieldName);
    if (cookieValue) {
      payload[fieldName] = cookieValue;
    }
  });

  return payload;
}

function getMarketingLeadsForm(otpNextAction) {
  if (otpNextAction) {
    const submitButton = document.querySelector(otpNextAction);
    if (submitButton) {
      const form = submitButton.closest('form');
      if (form) {
        return form;
      }
    }
  }

  return document.querySelector('.whatsapp-form');
}

function collectMarketingLeadsData(otpPhoneNumber, otpNextAction) {
  const form = getMarketingLeadsForm(otpNextAction);
  const payload = applyCookieFallbackToFormPayload(form, collectLeadsFormPayload(form));

  try {
    const tempLeadsData = JSON.parse(sessionStorage.getItem('temp_leads_contact_data') || '{}');
    if (!payload.name && tempLeadsData.name) {
      payload.name = tempLeadsData.name;
    }
    if (!payload.whatsapp_number && tempLeadsData.number) {
      payload.whatsapp_number = tempLeadsData.number;
    }
  } catch (error) {
    // Ignore invalid sessionStorage payload.
  }

  if (!payload.whatsapp_number && otpPhoneNumber) {
    payload.whatsapp_number = otpPhoneNumber;
  }

  if (payload.name) {
    payload.leads_name = payload.name;
  }

  if (payload.whatsapp_number) {
    payload.leads_phone = payload.whatsapp_number;
  }

  payload.current_url = window.location.href;

  const projectStatusField = document.querySelector('#nndc-footer__project-status');
  if (projectStatusField && projectStatusField.value) {
    payload.project_status = projectStatusField.value;
  }

  return payload;
}

function pushMarketingGtmConversion(otpPhoneNumber, otpNextAction) {
  if (!gl_params.marketing_gtm || !gl_params.marketing_gtm.enabled) {
    return;
  }

  try {
    window.dataLayer = window.dataLayer || [];

    const eventParams = Object.assign(
      {
        event: gl_params.marketing_gtm.conversion_event || 'otp_verified_conversion',
      },
      collectMarketingLeadsData(otpPhoneNumber, otpNextAction)
    );

    const conversionId = gl_params.marketing_gtm.conversion_id;
    const conversionLabel = gl_params.marketing_gtm.conversion_label;
    const conversionName = gl_params.marketing_gtm.conversion_name;

    if (conversionName) {
      eventParams.conversion_name = conversionName;
    }

    if (conversionId && conversionLabel) {
      eventParams.send_to = conversionId + '/' + conversionLabel;
    }

    window.dataLayer.push(eventParams);
  } catch (error) {
    // Prevent GTM tracking failures from breaking OTP success flow.
  }
}


function set_whatsapp_clean_number(number) {
  // remove non numeric
  number = number.replace(/\D/g,'');

  if (number != '') {
      // change first zero
      number = change_zero_to_country_code(number);
  }

  return number;
}

function change_zero_to_country_code(number) {
  if (number.charAt(0) == 0) {
    return '62' + number.substr(1);
  } else if (number.substring(0, 2) != '62')  {
    return '62' + number;
  }

  return number;
}



// WEBPACK FOOTER //
// ./scripts/global/otp.js